<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <h1>Links</h1>
        <ul>
          <li v-for="company in company_names" :key="company.name">{{ company.name }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
  export default {
    name: 'links',
    data() {
      return {
        company_names: []
      }
    },
    mounted: function(){
        this.getAllCompanyNames();
    },
    methods: {
			getAllCompanyNames: function(){
          let myself = this;
          //myself.company_names = [{"name":"Audi AG"},{"name":"BMW"},{"name":"Daimler Group"},{"name":"FCA"},{"name":"Ford"},{"name":"GM"},{"name":"Honda "},{"name":"Hyundai"},{"name":"Nissan"},{"name":"PSA"},{"name":"Renault"},{"name":"Toyota"}];

					this.axios.get("php/api.php?action=names").then(function(response){
              myself.company_names = response.data;
					});
			},
    }
  }
</script>
